module.exports = __webpack_public_path__ + "static/img/vip_privilege2.61ea98d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/vip/vip_privilege2.png
// module id = B/AO
// module chunks = 0